import { useDispenseLimitExceededActions } from '@/components/Patient/hooks/useDispenseLimitExceededActions';
import { Card, TextField, Typography } from '@montugroup/design-system';
import { Stack } from '@mui/material';

interface CreatePrescriptionDispenseNoteProps {
  onChange: (value: string) => void;
}

export const DispenseLimitExceededNote = ({ onChange }: CreatePrescriptionDispenseNoteProps) => {
  const { showNote } = useDispenseLimitExceededActions();

  if (!showNote) {
    return null;
  }

  return (
    <Card raised>
      <Stack spacing={2} padding={7}>
        <Typography variant="subtitle2">Dispense Note Required*</Typography>
        <Typography variant="body2">
          The prescribed amount of dried herb exceeds 100 grams. Please review the prescribed products and provide a
          clinical justification to support this prescription.
        </Typography>
        <TextField
          variant="outlined"
          label="Enter reason for prescribing over the limit."
          onChange={(e) => onChange(e.target.value)}
          inputProps={{ maxLength: 50 }}
        />
      </Stack>
    </Card>
  );
};
